import React, {useEffect, useState} from "react";
import ProductCard from "./ProductCard.js";
import {Element, Link} from "react-scroll";
import StickyBox from "react-sticky-box";
import ScrollContainer from "react-indiana-drag-scroll";
import AllProductsActionsBar from "./Actionsbar/AllProductsActionsBar";
import {FormattedMessage, FormattedNumber, IntlProvider} from 'react-intl';
import * as StorageService from "../services/StorageService.js";
import {LOCALSTORAGE_ITEMS, ORDER_PLACE, ORDER_PLACE as PLACES, USER_TYPES} from "../util/Constants";
import CampaignCard from "./CampaignCard";
import appScreenshotImg from "../assets/img/app_screenshot.png";
import arrowImg from "../assets/img/icon_arrow.svg";
import arrowImgRight from "../assets/img/icon_arrow_right.svg";
import {
    findMobileOperatingSystem,
    findMobileOperatingSystemAndGetLink,
    getCategoryName,
    getLastTwelveMonths,
    getProductsOrderFromCart
} from "../util/common.js";
import cartImg from "../assets/img/icon_cart.svg";
import {PATH} from "../routes/routes.js";
import BrandingWatermark from "./BrandingWatermark";
import * as ProductService from "../services/ProductService";
import {EventBus} from "../util/EventBus";
import Moment from "react-moment";
import {DATE_FORMAT} from "../util/DateUtil";
import ScanQrToContinue from "./ScanQrToContinue";
import {useNavigate} from "react-router";

function AllProductsList(props) {
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const ordersHistoryStorage = StorageService.getItem(LOCALSTORAGE_ITEMS.ORDERS_HISTORY) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.ORDERS_HISTORY)) : null;
    const userType = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) : null;
    const allowOrdering = shopDetails ? (typeof shopDetails?.merchantConfig?.allowOrdering !== "undefined" ? shopDetails?.merchantConfig?.allowOrdering : null) : false;
    const showDownloadApp = shopDetails ? (typeof shopDetails?.merchantConfig?.showDownloadApp !== "undefined" ? shopDetails.merchantConfig?.showDownloadApp : null) : false;
    const [isVisible, setIsVisible] = useState(StorageService.getItem(LOCALSTORAGE_ITEMS.CAMPAIGNS_ARE_VISIBLE) ? (StorageService.getItem(LOCALSTORAGE_ITEMS.CAMPAIGNS_ARE_VISIBLE) + "") === "true" : true);
    const navigateTo = useNavigate();
    const [currentCart, setCurrentCart] = useState(StorageService.getItem(LOCALSTORAGE_ITEMS.CURRENT_CART) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.CURRENT_CART)) : null);
    const currency = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS))?.currency;

    const arrLength = props.allTagsAndProducts.length;
    const [elRefs, setElRefs] = useState([]);
    const [totalCartProducts, setTotalCartProducts] = useState(0);

    const [ordersHistory, setOrdersHistory] = useState(ordersHistoryStorage);
    const [ordersHistoryPopupVisible, setOrdersHistoryPopupVisible] = useState(false);
    let userInfo = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO)) : null;
    const isBarPickup = shopDetails ? (typeof shopDetails?.merchantConfig?.barPickup !== "undefined" ? shopDetails?.merchantConfig?.barPickup : null) : false;
    const orderPlace = StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_PLACE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_PLACE) : null;

    useEffect(() => {
        if (props.allTagsAndProducts.length === 0) {
            return;
        }else{
            initializeCurrentCart();
        }

    }, [props.allTagsAndProducts]);

    React.useEffect(() => {
        // add or remove refs
        setElRefs(elRefs => (
            Array(arrLength).fill().map((_, i) => elRefs[i] || React.createRef())
        ));
    }, [arrLength]);

    React.useEffect(() => {
        StorageService.setItem(LOCALSTORAGE_ITEMS.CAMPAIGNS_ARE_VISIBLE, isVisible);
    }, [isVisible]);

    React.useEffect(() => {
        getAllProductsOrders();
    }, []);

    const initializeCurrentCart = () => {
        let localStorageCurentCart = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.CURRENT_CART));
        if (localStorageCurentCart) {
            setCurrentCart(localStorageCurentCart);

            let tempTotalCartPrice = 0;
            let tempTotalQuantity = 0;
            for (const property in localStorageCurentCart) {
                for (const product in localStorageCurentCart[property]) {
                    localStorageCurentCart[property][product].choices.forEach(c => {
                        tempTotalCartPrice += c.price * localStorageCurentCart[property][product].quantity;
                    });
                    tempTotalQuantity += localStorageCurentCart[property][product].quantity;
                }
            }

            setTotalCartProducts(tempTotalQuantity);

            return;
        }
        let quantities = {};
        props.allTagsAndProducts.forEach((tag, index) => {
            quantities = {
                ...quantities,
                [tag.name]: {},
            };
        });

        setCurrentCart(quantities);
        // this is created once on the homepage
        StorageService.setItem(LOCALSTORAGE_ITEMS.CURRENT_CART, JSON.stringify(quantities));
    }
    const getAllProductsOrders = async () => {
        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "fromDate": getLastTwelveMonths()
        }


        const response = await ProductService.getAllProductsOrders(body);
        if (response.ok) {
            setOrdersHistory(response.data.orders);
            StorageService.setItem(LOCALSTORAGE_ITEMS.ORDERS_HISTORY, JSON.stringify(response.data.orders));
        } else {
            EventBus.dispatch("genericErrorMsg");
        }
    }


    const toggleClass = () => {
        setIsVisible(!isVisible);
    };

    const toOrderSummaryPage = () => {
        if (isBarPickup && orderPlace === PLACES.BAR) {
            navigateTo(PATH.BAR_THANK_YOU + "/" + StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID))
        } else {
            navigateTo(PATH.ORDER_SUMMARY)
        }

    }

    const openOrderHistoryPopup = () => {
        setOrdersHistoryPopupVisible(!ordersHistoryPopupVisible);
    }

    const toOrderReviewPage = () => {
        const allProducts = [];

        for (const property in currentCart) {
            for (const productName in currentCart[property]) {
                if (allProducts.find(product => productName === product.name)) {
                    continue;
                }
                allProducts.push(currentCart[property][productName]);
            }
        }

        let localStorageSubOrders = StorageService.getItem(LOCALSTORAGE_ITEMS.SUBORDERS);
        let newLocalStorageSubOrders;

        if (localStorageSubOrders) {
            newLocalStorageSubOrders = JSON.parse(localStorageSubOrders)
            newLocalStorageSubOrders.push(allProducts);
            StorageService.setItem(LOCALSTORAGE_ITEMS.SUBORDERS, JSON.stringify(newLocalStorageSubOrders));
        } else {
            StorageService.setItem(LOCALSTORAGE_ITEMS.SUBORDERS, JSON.stringify([allProducts]));
        }

        if (props.isTakeAwayMenu) {
            if ((userType === USER_TYPES.ANONYMOUS || userType === null) && (userInfo === null || userInfo === undefined || !userInfo.phone)) {
                navigateTo({
                    pathname: PATH.PROFILE_UPDATE_PHONE,
                    search: "?redirect=" + PATH.TAKEAWAY
                });
            } else {
                if (userType === USER_TYPES.VERIFIED && orderPlace !== ORDER_PLACE.TABLE && (userInfo?.phone === null || userInfo.phone === undefined || userInfo.phone === "")) {
                    navigateTo(PATH.PROFILE_UPDATE_PHONE);
                } else {
                    navigateTo(PATH.TAKEAWAY_ORDER_REVIEW);
                }
            }

        } else if (orderPlace === ORDER_PLACE.BAR) {
            if ((userType === USER_TYPES.ANONYMOUS || userType === null) && (userInfo === null || userInfo === undefined || !userInfo.phone)) {
                navigateTo({
                    pathname: PATH.PROFILE_UPDATE_PHONE,
                    search: "?redirect=" + PATH.ALL_PRODUCTS
                });
            } else {
                if (userType === USER_TYPES.VERIFIED && (userInfo?.phone === null || userInfo.phone === undefined || userInfo.phone === "")) {
                    navigateTo(PATH.PROFILE_UPDATE_PHONE);
                } else {
                    navigateTo(PATH.ORDER_REVIEW);
                }
            }
        } else {
            if (userType === USER_TYPES.VERIFIED && orderPlace !== ORDER_PLACE.TABLE && (userInfo?.phone === null || userInfo.phone === undefined || userInfo.phone === "")) {
                navigateTo(PATH.PROFILE_UPDATE_PHONE);
            } else {
                navigateTo(PATH.ORDER_REVIEW);
            }
        }

    }

    const getTotalPrice = (orderDetails) => {
        let price = 0;
        orderDetails?.forEach(product => {
            product.choices.forEach(c => {
                price += c.price * c.quantity;
            });
        })
        return price;
    }

    const scrollToCategory = id => {
        if (findMobileOperatingSystem() === "ios") {
            elRefs[id]?.current.scrollIntoView({
                inline: "center",
                behavior: "smooth",
                block: "nearest"
            });
        } else {
            elRefs[id]?.current.scrollIntoView({
                inline: "center",
                behavior: "smooth",
            });
        }

    };

    const showBannerBetweenCategories = (categoryIndex) => {

        let showBanner = false;
        let numberOfCategories = props.allTagsAndProducts.length;
        const middleOfTheList = Math.round(numberOfCategories / 2);

        if (numberOfCategories < 3) {
            if (categoryIndex + 1 === numberOfCategories) {
                showBanner = true;
            }
        } else {
            if (categoryIndex + 1 === numberOfCategories) {
                showBanner = true;
            }
            if (categoryIndex + 1 === middleOfTheList) {
                showBanner = true;
            }
        }
        return showBanner;
    }

    async function addAllOrderProductsInStorage(orderId) {
        StorageService.setItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS, JSON.stringify(ordersHistoryStorage.find(order => order.oid === orderId)));
    }

    const toOrderHistoryPage = (e, orderId) => {
        addAllOrderProductsInStorage(orderId).then(() => {
            navigateTo(PATH.ORDER_HISTORY + "/" + orderId);
        });

    }

    return (
        <>
            <StickyBox className="sticky-box">
                <ScrollContainer className="scroll-container">
                    <ul>
                        {StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME) ?

                            props.allCampaigns && props.allCampaigns.length > 0 &&
                            <li style={{
                                order: "-1",
                            }}
                            >
                                <Link
                                    activeClass="active"
                                    to={"campaigns-container"}
                                    spy={true}
                                    smooth={true}
                                    duration={500}
                                    offset={-50}
                                >
                                    <FormattedMessage id="Campaigns"/>
                                </Link>
                            </li>

                            : null}

                        {props.allTagsAndProducts.map((category, index) => (
                            category.name.length > 0 && <li
                                key={index}
                                ref={elRefs[index]}
                            >
                                <Link
                                    data-qa={"category-" + getCategoryName(category?.name?.toLowerCase())}
                                    activeClass="active"
                                    className={index}
                                    to={index.toString()}
                                    spy={true}
                                    smooth={true}
                                    duration={500}
                                    offset={-50}
                                    onSetActive={() => scrollToCategory(index)}

                                >
                                    {getCategoryName(category.name)}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </ScrollContainer>
            </StickyBox>

            {StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME) ?

                props.allCampaigns && props.allCampaigns.length > 0 ?
                    <div className="campaigns-container">
                        <div onClick={toggleClass} className="row trigger-row">
                            <div className="category-title">
                                <h2><FormattedMessage id="Campaigns"/></h2>
                            </div>
                            <div className={isVisible ? "minimize-btn" : "minimize-btn closed"}>
                                <img className="arrow-img" src={arrowImg} alt={"minimize btn arrow"}/>
                            </div>
                        </div>

                        <div className={isVisible ? "campaigns-content" : "campaigns-content closed"}>
                            {/*<div className="banner campaigns-banner">*/}
                            {/*    <div className="row">*/}
                            {/*        <p><FormattedMessage id="CampaignsAreAvailableOnlyInApp"/></p>*/}
                            {/*        <a target="_blank" href={findMobileOperatingSystemAndGetLink()}*/}
                            {/*           className="btn btn-special"><FormattedMessage id="GetApp"/></a>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <ScrollContainer className="scroll-container">
                                <div className="all-campaigns-list">
                                    <>
                                        {
                                            props.allCampaigns.map((campaign, productIndex) => {
                                                    return (<CampaignCard
                                                        key={productIndex + campaign}
                                                        campaign={campaign}
                                                    />)
                                                }
                                            )
                                        }
                                    </>
                                </div>

                            </ScrollContainer>
                        </div>
                    </div>

                    :

                    <>
                        {((showDownloadApp === true || showDownloadApp === null) && (allowOrdering === true || allowOrdering === null)) ?
                            <div className="banner campaigns-banner">
                                <div className="row">
                                    <p><FormattedMessage id="DownloadTheAppForABetterExperience"/></p>
                                    <a target="_blank" href={findMobileOperatingSystemAndGetLink()}
                                       className="btn btn-special"><FormattedMessage id="GetApp"/></a>
                                </div>
                            </div>
                            :
                            null

                        }
                    </>
                : <ScanQrToContinue/>
            }

            {props.allTagsAndProducts.length > 0 ?
                <div className="list">
                    {props.allTagsAndProducts.map((category, categoryIndex) => {
                        let ok;
                        const numberOfCategories = props.allTagsAndProducts.length;
                        const middleOfTheList = Math.round(numberOfCategories / 2);
                        if (categoryIndex + 1 === numberOfCategories) {
                            ok = true;
                        }
                        if (categoryIndex + 1 === middleOfTheList) {
                            ok = true;
                        }

                        return (
                            <Element
                                name={categoryIndex.toString()}
                                key={"display" + categoryIndex}
                            >

                                <div className="category-title">
                                    <h2>{getCategoryName(category.name)}</h2>
                                    <div className="products-list" data-qa="products-list">
                                        {category.products.map((product, productIndex) => {
                                            return (<ProductCard
                                                key={productIndex}
                                                product={product}
                                                category={category.name}
                                                hasOptions={product.options && product.options.length > 0}
                                                quantity={currentCart?.[category.name]?.[product.name]?.quantity || 0}
                                                isTakeAwayMenu={props.isTakeAwayMenu}
                                            />)
                                        })}
                                    </div>

                                </div>
                                {
                                    (showDownloadApp === true || showDownloadApp === null) && (allowOrdering === true || allowOrdering === null) ?
                                        showBannerBetweenCategories(categoryIndex) &&
                                        <div className="banner vouchers-banner">
                                            <img alt="app screenshot" src={appScreenshotImg}/>
                                            <div className="row">
                                                <FormattedMessage id="VouchersSpecialOffersBannerMsg"/>
                                                <a target="_blank" href={findMobileOperatingSystemAndGetLink()}
                                                   className="btn btn-special"><FormattedMessage id="GetApp"/></a>
                                            </div>
                                        </div>
                                        : null
                                }
                            </Element>
                        )
                    })}
                    {(showDownloadApp === true || showDownloadApp === null) && <BrandingWatermark/>}
                    <br/>
                    {ordersHistory && ordersHistory?.length > 0 &&
                        <a className="btn-cart" onClick={openOrderHistoryPopup}>
                            <div className="row label-and-icon-row">
                                <img alt="cart" src={cartImg}/><FormattedMessage id="OrdersHistory"/>
                            </div>

                            <div
                                className={ordersHistoryPopupVisible ? "order-history-container visible" : "order-history-container"}>
                                {
                                    ordersHistory?.map((order, index) => (
                                        <div key={index} onClick={(e) => toOrderHistoryPage(e, order.oid)}
                                             className="order-history-card row">
                                            <div className="col left-col">
                                                <div className="row shop-title">{shopDetails.title}</div>
                                                <div className="row order-id"><FormattedMessage
                                                    id="OrderNumber"/>&nbsp;{order.oid}</div>
                                                <div className="row order-date-and-time">
                                                    <Moment
                                                        format={DATE_FORMAT.DAY_MONTH_YEAR_HOUR_MINUTES}
                                                        date={order.lastMod}
                                                    />
                                                </div>
                                                <div
                                                    className={"row order-status " + order.procStatus.toLowerCase()}>{order.procStatus}</div>
                                            </div>
                                            <div className="right-col">
                                                <div className="col">
                                                    <div className="row total-label">
                                                        <FormattedMessage id="Total"/>
                                                    </div>
                                                    <div className="row total-price">
                                                        <IntlProvider
                                                            locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                                            <FormattedNumber
                                                                value={order.price / 100.0}
                                                                style="currency"
                                                                minimumFractionDigits={2}
                                                                maximumFractionDigits={2}
                                                                currency={currency}/>
                                                        </IntlProvider>
                                                    </div>
                                                </div>
                                                <div className="col icon-col">
                                                    <img alt="arrow right" src={arrowImgRight}/>
                                                </div>
                                            </div>

                                        </div>
                                    ))
                                }
                            </div>

                        </a>}
                    {props.hasCartBtn && props.allTagsAndProducts.length ?
                        <a className="btn-cart" onClick={toOrderSummaryPage}>
                            <div className="row label-and-icon-row">
                                <img alt="cart" src={cartImg}/><FormattedMessage id="ActiveOrder"/>
                            </div>
                        </a>
                        : null}
                </div>
                : null
            }
            {/*<BrandingWatermark/>*/}
            {/*<br/>*/}
            {!!props.allTagsAndProducts.length &&
                <AllProductsActionsBar
                    isVisible={!!totalCartProducts}
                    totalProducts={totalCartProducts}
                    totalPrice={
                        <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                            <FormattedNumber
                                value={getTotalPrice(getProductsOrderFromCart(currentCart)) / 100.0}
                                style="currency"
                                minimumFractionDigits={2}
                                maximumFractionDigits={2}
                                currency={currency}
                                roundingMode="halfEven"
                            />
                        </IntlProvider>
                    }
                    buttonName={<FormattedMessage id="NextStep"/>}
                    btnClassName={"btn btn-default btn-xl"}
                    buttonAction={() => toOrderReviewPage()}
                />
            }
        </>
    );

}


export default AllProductsList;
